<template>
  <div :class="darkModeClass">
    <div class="tab-group">
      <slot>
        <Heading :level="1" v-text="panel.name" v-if="panel.showTitle" />

        <p
          v-if="panel.helpText"
          :class="panel.helpText ? 'mt-2' : 'mt-3'"
          class="text-gray-500 text-sm font-semibold italic"
          v-html="panel.helpText"
        ></p>
      </slot>

      <div :class="[panel.showTitle && !panel.showToolbar ? 'mt-3' : '']">
        <div id="tabs" class="overflow-hidden">
          <div class="block overflow-x-auto overflow-y-hidden">
            <nav
              aria-label="Tabs"
              class="isolate flex divide-x divide-gray-200 dark:divide-gray-700 rounded-2xl nova-tabs"
            >
              <a
                v-for="(tab, key) in getSortedTabs(tabs)"
                :key="key"
                :dusk="tab.slug + '-tab'"
                :class="
                  [
                    getIsTabCurrent(tab)
                    ? 'active text-' + getCurrentColor() + '-500 font-bold'
                    : 'font-medium text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-200',

                    {'rounded-l-2xl': key === 0},
                    {'rounded-r-2xl': key === getSortedTabs(tabs).length - 1},
                  ]
                "
                class="block relative flex-none overflow-hidden bg-white dark:bg-gray-800 py-4 px-4 text-center text-sm leading-snug whitespace-normal break-words min-h-[3.5rem] min-w-[33%] focus:z-10 cursor-pointer tab-item"
                :style="getTabWidth()"
                @click.prevent="handleTabClick(tab)"
              >
                <span class="capitalize block">{{ tab.properties.title }}</span>
                <span
                  v-if="getIsTabCurrent(tab)"
                  aria-hidden="true"
                  class="absolute inset-x-0 bottom-0 h-0.5"
                  :class="'bg-' + getCurrentColor() + '-500'"
                ></span>
              </a>
            </nav>
          </div>
        </div>

        <div
          v-for="(tab, index) in getSortedTabs(tabs)"
          :key="'related-tabs-fields' + index"
          :ref="getTabRefName(tab)"
          :class="['tab', tab.slug]"
          class="mt-3"
          :label="tab.name"
          v-show="getIsTabCurrent(tab)"
        >
          <div>
            <div
              v-if="getAllFieldsExceptRelatable(tab).length"
              class="bg-white dark:bg-gray-800 rounded-2xl py-2 px-6 divide-y divide-gray-100 dark:divide-gray-700"
            >
              <KeepAlive
                v-for="(field, index) in getAllFieldsExceptRelatable(tab)"
                :key="index"
              >
                <component
                  :is="getComponentName(field)"
                  class="flex flex-col -mx-6 px-6 py-2 md:py-0 space-y-2 md:space-y-0"
                  :class="{
                    'remove-bottom-border': index === tab.fields.length - 1,
                  }"
                  :field="field"
                  :index="index"
                  :resource="resource"
                  :resource-id="resourceId"
                  :resource-name="resourceName"
                  @actionExecuted="actionExecuted"
                />
              </KeepAlive>
            </div>
            <div v-if="getAllRelatableFields(tab).length">
              <KeepAlive
                v-for="(field, index) in getAllRelatableFields(tab)"
                :key="index"
              >
                <div class="mt-8">
                  <div
                    v-if="
                      getHeadingVisibilityForAttribute(tab, field.attribute)
                    "
                    class="border-b border-gray-400 dark:border-gray-700 pb-3 mb-5"
                  >
                    <h2
                      class="font-normal text-xl md:text-xl flex items-center"
                    >
                      <span>{{ field.name }}</span>
                    </h2>
                  </div>
                  <component
                    :is="getComponentName(field)"
                    :class="{
                      'remove-bottom-border': index === tab.fields.length - 1,
                    }"
                    :field="field"
                    :index="index"
                    :resource="resource"
                    :resource-id="resourceId"
                    :resource-name="resourceName"
                    @actionExecuted="actionExecuted"
                  />
                </div>
              </KeepAlive>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BehavesAsPanel from '../mixins/BehavesAsPanel'
import HasTabs from '../mixins/HasTabs'

export default {
  mixins: [BehavesAsPanel, HasTabs],
  data: () => ({
    tabMode: 'detail',
  }),
  methods: {
    getAllFieldsExceptRelatable(tab) {
      return tab.fields.filter(field => !field.relatable)
    },
    getAllRelatableFields(tab) {
      return tab.fields.filter(field => field.relatable)
    },
    getTabWidth() {
      const tabsCount = this.getSortedTabs(this.tabs).length
      const minTabsForScroll = 5
      
      if (tabsCount < minTabsForScroll) {
        // اگر کمتر از 5 تا تب بود، عرض را بر اساس تعداد واقعی محاسبه کن
        const widthPercent = 100 / tabsCount
        return {
          '--tab-width-desktop': `${widthPercent}%`
        }
      }
      
      // اگر 5 تا یا بیشتر بود، حداقل 20% (برای اسکرول)
      return {
        '--tab-width-desktop': '20%'
      }
    },
  },
}
</script>

<style scoped>
@media (min-width: 640px) {
  .tab-item {
    min-width: var(--tab-width-desktop, 20%);
  }
}
</style>
